<template>
    <div class="xc-btn-select-item">
        {{title}}
    </div>
</template>

<script>
export default {
    name: "XcBtnSelectItem",
    data() {
        return {
            isHide: true,
        }
    },
    props: {
        title: {
            type: String,
            default: "标题"
        },
    },
}
</script>

<style scoped lang="scss">
.xc-btn-select-item {
    width: 100%;
    height: 30px;
    color: #507dde;
    font-size: 12px;
    text-align: center;
    line-height: 30px;
    border-bottom: solid 1px rgba(207, 213, 224, 0.29);
    cursor: pointer;
    &:last-of-type {
        border: 0;
    }
}
</style>
